import classNames from 'classnames'

import { SIZE } from '../../../constants/size'
import { MODAL_BUTTONS_VARIANT } from '../Modal.constants'

import * as styles from './Buttons.module.css'

function Buttons({
  children,
  className,
  size = SIZE.MEDIUM,
  variant = MODAL_BUTTONS_VARIANT.REGULAR,
  ...divProps
}) {
  const buttonsClass = classNames(
    styles.buttons,
    styles[`${size}Size`],
    styles[variant],
    className
  )

  return (
    <div {...divProps} className={buttonsClass}>
      {children}
    </div>
  )
}

export default Buttons
